import { PageHeader } from '../ui/index.js';
import { ImageStudioSection } from './ImageStudioSection.js';

/**
 * S33 — Image Studio (Dedicated standalone page).
 *
 * Dedicated console for high-resolution brand gallery lookup,
 * variant-specific packshots extraction, selection, and direct
 * WooCommerce synchronization.
 */
export function ImageStudioPage(): React.ReactElement {
  return (
    <div className="space-y-4">
      <PageHeader
        index="S33"
        title="Image Studio"
        purpose="Studio packshots & photos officielles HD. Récupération directe depuis les sites officiels de marques (Caudalie, Bioderma, Cavaillès, Nuxe, SVR…), sélection de galerie et publication WooCommerce."
      />
      <ImageStudioSection />
    </div>
  );
}
